export default __webpack_public_path__ + "static/media/save.ffc86e5d.svg";